module.exports = __webpack_public_path__ + "img/sign_pass.c2c99c21.png";